import {
  UPDATE_LOGIN_MODAL,
  UPDATE_ADD_HACK_MODAL,
  UPDATE_SHARE_NEWS_MODAL,
  UPDATE_ADD_REVIEW_MODAL,
  UPDATE_RESET_PASSWORD_MODAL,
  
  UPDATE_COMPANY_MODAL,
  UPDATE_HACKER_MODAL,
  UPDATE_ORGANIZER_MODAL,

  CLOSE_ALL_MODALS,

  LOGIN,
  LOGIN_WITH_TOKEN,
  REGISTER,
  LOGOUT,
  LOGIN_PAGE_UNLOADED,
  UPDATE_ACTIVE_FORM,
  REFRESH_TOKEN,
  
  SET_USER,
  RESET_USER,
  SET_USER_PROJECTS,
  GET_USER_EVENTS,
  GET_USER_WALLET,
  UPDATE_SOCIAL_NETWORKS,
  UPDATE_SKILLS_AND_ROLES,
} from 'src/constants/actionTypes';

import { Auth, User, Project } from 'src/api';


function action(type, payload = {}) {
  if (typeof payload === 'function' || typeof payload.then === 'function') {
    return {type, payload}
  }
  return { type, ...payload };
}

export const auth = {
  loginWithToken: (token) => action(LOGIN_WITH_TOKEN, Auth.loginWithToken(token)),
  login: (user, pwd) => action(LOGIN, Auth.login(user, pwd)),
  register: (user, pwd, email) => action(REGISTER, Auth.register(user, pwd, email)),
  resetPassword: () => {},
  logout: () => action(LOGOUT), // Auth.logout() - ?(currently there's no api call)
  resetState: () => action(LOGIN_PAGE_UNLOADED),
  updateActiveForm: (activeForm) => action(UPDATE_ACTIVE_FORM, { activeForm }),
  refreshToken: (token) => action(REFRESH_TOKEN, Auth.refreshToken(token)),
}

export const modalWindows = {
  openLoginModal: () => action(UPDATE_LOGIN_MODAL, { opened: true }),
  closeLoginModal: () => action(UPDATE_LOGIN_MODAL, { opened: false }),
  openAddHackatonModal: () => action(UPDATE_ADD_HACK_MODAL, { opened: true }),
  closeAddHackatonModal: () => action(UPDATE_ADD_HACK_MODAL, { opened: false }),
  openShareNewsModal: () => action(UPDATE_SHARE_NEWS_MODAL, { opened: true }),
  closeShareNewsModal: () => action(UPDATE_SHARE_NEWS_MODAL, { opened: false }),
  openAddReviewModal: () => action(UPDATE_ADD_REVIEW_MODAL, { opened: true }),
  closeAddReviewModal: () => action(UPDATE_ADD_REVIEW_MODAL, { opened: false }),
  openResetPwdModal: (resetToken) => action(UPDATE_RESET_PASSWORD_MODAL, { opened: true, resetToken }),
  closeResetPwdModal: () => action(UPDATE_RESET_PASSWORD_MODAL, { opened: false }),
  openCompany: () => action(UPDATE_COMPANY_MODAL, { opened: true }),
  closeCompany: () => action(UPDATE_COMPANY_MODAL, { opened: false }),
  openHacker: () => action(UPDATE_HACKER_MODAL, { opened: true }),
  closeHacker: () => action(UPDATE_HACKER_MODAL, { opened: false }),
  openOrganizer: () => action(UPDATE_ORGANIZER_MODAL, { opened: true }),
  closeOrganizer: () => action(UPDATE_ORGANIZER_MODAL, { opened: false }),
  closeAllModals: () => action(CLOSE_ALL_MODALS),
}

export const user = {
  getUserProfile: () => action(SET_USER, User.getUserProfile()),
  getUserProjects: () => action(SET_USER_PROJECTS, Project.refetchUserProjects()),
  refetchUserEvents: () => action(GET_USER_EVENTS, User.refetchUserEvents()),
  refetchUserWallet: () => action(GET_USER_WALLET, User.refetchUserWallet()),
  resetUser: () => action(RESET_USER),
  updateUserSocialNetwork: (socialNetworks) => action(UPDATE_SOCIAL_NETWORKS, { socialNetworks }),
  updateSkillsAndRoles: (skillsAndRoles) => action(UPDATE_SKILLS_AND_ROLES, skillsAndRoles),
}


// WEBPACK FOOTER //
// ./src/actions/index.js